import React, { useEffect, useState } from 'react';
import Toast from '../../molecules/Toast';
import { useLocation, useNavigate } from 'react-router-dom';
import Step1 from './Step1';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
import LeadsColumnMaping from './LeadsColumnMaping';
import CampaignSettings from './CampaignSettings';
import campaignService from '../../../services/campaignService';
import Loaders from '../Loaders';
import { BiSolidCheckCircle } from 'react-icons/bi';
import StepLeads from './StepLeads';
import CampaignAnalytics from '../CampaignAnalytics';
import { StepBtnsWrap, StyledCompaignTask } from './CreateCompaign.styles';
import AICampaign from './AICampaign';

const CreateCompaign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { campaign_id, isEdit, campaign_type } = location.state || {};
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [isStep7Empty, setIsStep7Empty] = useState(true);
  const [step, setStep] = useState(1);
  const NextStep = () => setStep(prev => prev + 1);
  const prevousStep = () => setStep(prev => prev - 1);


  useEffect(() => {
    if (location?.state?.isEdit) {
      setEditLoading(true);
      setTimeout(() => setEditLoading(false), 1800);
    }
  }, [location?.state?.isEdit]);

  useEffect(() => {
    if (isEdit) setStep(10);
  }, [isEdit]);

  useEffect(() => {
    const SESSION_KEY = 'create-campaign-active';
    const alreadyActive = sessionStorage.getItem(SESSION_KEY) === 'true';

    if (alreadyActive) {
      sessionStorage.removeItem(SESSION_KEY);
      navigate('/campaign-manager', { replace: true });
      return;
    }

    sessionStorage.setItem(SESSION_KEY, 'true');

    return () => {
      sessionStorage.removeItem(SESSION_KEY);
    };
  }, [navigate]);

  useEffect(() => {
    const campaignId = location?.state?.campaign_id || campaign_id;
    const editMode = location?.state?.isEdit || isEdit;

    if (editMode && campaignId) {
      // Check Step7 data
      const checkStep7Data = async () => {
        try {
          const res = await campaignService.getCampaignScheduleSettings(campaignId);
          const scheduleData = res.data;

          if (scheduleData) {
            const hasTimezone = !!scheduleData?.timezone;
            const hasStartHour = !!scheduleData?.startHour;
            const hasEndHour = !!scheduleData?.endHour;
            const hasDays = scheduleData?.daysOfWeek && scheduleData.daysOfWeek.length > 0;
            const hasDailyLimit = scheduleData?.dailyLimit && Number(scheduleData.dailyLimit) > 0;

            const isEmpty = !(hasTimezone && hasStartHour && hasEndHour && hasDays && hasDailyLimit);
            setIsStep7Empty(isEmpty);
          } else {
            setIsStep7Empty(true);
          }
        } catch (err) {
          // If API call fails, assume step is empty
          setIsStep7Empty(true);
        }
      };

      checkStep7Data();
    }
  }, [isEdit, location?.state?.isEdit, location?.state?.campaign_id, campaign_id]);

  const topStepButtons = [
    { id: 10, label: 'Analytics', showOnEditOnly: true },
    { id: 1, label: 'Basics', hideOnEdit: true },
    { id: 2, label: 'Leads' },
    ...(campaign_type === 'ai' ? [{ id: 11, label: 'AI Campaign' }] : []),
    { id: 6, label: 'Sequence' },
    { id: 7, label: 'Schedule' },
    { id: 8, label: <>{isEdit ? 'Options' : 'Launch'}</> },
  ];

  const visibleSteps = topStepButtons.filter(step => {
    if (step.showOnEditOnly && !isEdit) return false;
    if (step.hideOnEdit && isEdit) return false;
    return true;
  });

  const stepToProgressMap = {
    1: 1,
    2: 2,
    ...(campaign_type === "ai" ? { 11: 3 } : {}),
    ...(campaign_type === "ai" ? { 6: 4 } : { 6: 3 }),
    ...(campaign_type === "ai" ? { 7: 5 } : { 7: 4 }),
    ...(campaign_type === "ai" ? { 8: 6 } : { 8: 5 }),
  };

  const currentProgressStep = stepToProgressMap[step] || 1;

  const progressPercent = (currentProgressStep / Object.keys(stepToProgressMap).length) * 100;
  return (
    <StyledCompaignTask
      $step={step}
      $flexEnd={
        isEdit || (step === 6 && data?.step1?.list_id) || step === 7 || step === 8
      }
      className={isEdit ? 'edit-mode' : ''}
      $noPadding={step === 10}>
      <StepBtnsWrap>
        {topStepButtons
          ?.filter(step => {
            if (step.showOnEditOnly && !isEdit) return false;
            if (step.hideOnEdit && isEdit) return false;
            return true;
          })
          .map(({ id, label }) => {
            const isActive = step === id;
            const isCompleted =
              !isEdit && (stepToProgressMap[step] || 0) > (stepToProgressMap[id] || 0);
            const isDisabled = isEdit && id === 8 && isStep7Empty;

            return (
              <span
                key={id}
                className={`step-btn ${isActive ? 'active' : isCompleted ? 'completed' : ''} ${isEdit ? 'edit' : ''} ${isEdit && !isDisabled ? 'clickable' : 'disabled'
                  }`}
                onClick={() => {
                  if (isEdit && isDisabled && id === 8) {
                    Toast({ type: 'error', message: 'Please enter data in Schedule to proceed' });
                    return;
                  }
                  if (isEdit && !isDisabled) setStep(id);
                }}>
                <BiSolidCheckCircle className={!isEdit && isCompleted ? 'tick active' : 'tick'} />
                {label}
              </span>
            );
          })}
      </StepBtnsWrap>
      {/* Progress Bar */}
      <div className="progress-bar">
        {!isEdit && <div className="progress-fill" style={{ width: `${progressPercent}%` }}></div>}
      </div>
      {editLoading ? (
        <div className="edit-loading-wrapper">
          <Loaders viewLoader />
        </div>
      ) : (
        <>
          {' '}
          {step === 6 ? (
            <div className="steps-holder sequence">
              {' '}
              {step === 6 && (
                <Step6
                  setData={setData}
                  data={data}
                  NextStep={NextStep}
                  loading={loading}
                  setLoading={setLoading}
                  goBack={prevousStep}
                  step={step}
                  setStep={setStep}
                  defaultLocked={data?.isEnrichment}
                  isEdit={isEdit}
                />
              )}{' '}
            </div>
          ) : (
            <div className="steps-holder">
              {' '}
              <>
                {step === 1 && (
                  <Step1 setData={setData} NextStep={NextStep} data={data} step={step} setStep={setStep} />
                )}{' '}
                {step === 2 && (
                  <StepLeads
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                    isEdit={isEdit}
                  />
                )}
                {step === 3 && (
                  <Step4
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    setStep={setStep}
                    goBack={prevousStep}
                    step={step}
                  />
                )}{' '}
                {step === 4 && (
                  <CampaignSettings
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    loading={loading}
                    goBack={prevousStep}
                  />
                )}{' '}
                {step === 5 && (
                  <Step5
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    loading={loading}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                  />
                )}
                {step === 7 && (
                  <Step7
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    loading={loading}
                    setLoading={setLoading}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                    isEdit={isEdit}
                    onStep7DataChange={setIsStep7Empty}
                  />
                )}{' '}
                {step === 8 && (
                  <Step8
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    loading={loading}
                    setLoading={setLoading}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                    isEdit={isEdit}
                  />
                )}{' '}
                {step === 9 && (
                  <LeadsColumnMaping
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                  />
                )}
                {step === 10 && (
                  <CampaignAnalytics
                    setData={setData}
                    data={data}
                    NextStep={NextStep}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                    isEdit={isEdit}
                  />
                )}
                {step === 11 && (
                  <AICampaign
                    data={data}
                    isEdit={isEdit}
                    setData={setData}
                    NextStep={NextStep}
                    goBack={prevousStep}
                    step={step}
                    setStep={setStep}
                  />
                )}
              </>
            </div>
          )}{' '}
        </>
      )}{' '}
    </StyledCompaignTask>
  );
};

export default CreateCompaign;
